<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="ball-fussion" [fullScreen]="true">
  <p style="color: white; font-size: 1.3rem;"> {{msg}} </p>
</ngx-spinner>